import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginLogsComponent } from './login-logs/login-logs.component';

const routes: Routes = [
  {
    path: '',
    component: LoginLogsComponent
  },
  // {
  //   path: 'add',
  //   component: AddUpdateStoriesComponent
  // },
  // {
  //   path: 'update/:id',
  //   component: AddUpdateStoriesComponent
  // }
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LoginLogsRoutingModule { }
